import { type ComponentType } from 'react'
import { HelpOutlineOutlined } from '@mui/icons-material'
import { Button, Menu, type ButtonProps, type MenuProps } from '@mui/material'
import { styled } from '@mui/material/styles'
import { MENU_ICON_SIZE } from './learn-button.constants'

export const LearnMenuButton: ComponentType<ButtonProps> = styled( Button )( ( { theme } ) => ( {
	'color': theme.palette.text.primary,
	'&:hover': {
		backgroundColor: theme.palette.action.hover,
	},
} ) )

export const LearnMenu: ComponentType<MenuProps> = styled( Menu )( {
	width: 300,
} )

export const HelpMenuIcon: ComponentType = styled( HelpOutlineOutlined )( {
	fontSize: MENU_ICON_SIZE,
} )
